// extracted by mini-css-extract-plugin
export var acitonButtons = "_fs-0";
export var additionalIcon = "_fs-f";
export var block = "_fs-1";
export var blockContent = "_fs-7";
export var blockDescription = "_fs-8";
export var blockIcon = "_fs-9";
export var blockTitle = "_fs-6";
export var border = "_fs-a";
export var center = "_fs-l";
export var edge = "_fs-b";
export var edgeLabel = "_fs-c";
export var edgePath = "_fs-d";
export var error = "_fs-e";
export var flowchart = "_fs-g";
export var flowchartContent = "_fs-h";
export var highlighted = "_fs-3";
export var hover = "_fs-4";
export var icon = "_fs-i";
export var left = "_fs-m";
export var navButton = "_fs-j";
export var navButtons = "_fs-k";
export var right = "_fs-n";
export var selected = "_fs-2";
export var small = "_fs-5";